import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { apiRequest } from "../apiService/allapi";
import Swal from "sweetalert2";
const Contact = () => {
  const [contact, setContact] = useState({});

  const getcontact = async () => {
    const token = localStorage.getItem("token");

    const res = await apiRequest("/User/getContact", "GET", null, {
      Authorization: `Bearer ${token}`,
    });
   
    if (res?.data?.status === true) {
      setContact(res.data.data);
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const submitContact = async (e) => {
    e.preventDefault();
    // Validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.mobile ||
      !formData.subject ||
      !formData.message
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill all fields",
      });

      return;
    }
    try {
      const token = localStorage.getItem("token");

      const payload = {
        name: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      };

      const res = await apiRequest("/User/addContact", "POST", payload, {
        Authorization: `Bearer ${token}`,
      });

      console.log(res.data);

      if (res?.data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Custom Request Submitted Successfully",
        });

        setFormData({
          name: "",
          mobile: "",
          email: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getcontact();
  }, []);

  return (
    <>
      <section className="contact py-80">
        <div className="container container-lg">
          <div className="row gy-5">
            <div className="col-lg-8">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <form onSubmit={submitContact}>
                  <h6 className="mb-32">Make Custom Request</h6>

                  <div className="row gy-4">
                    {/* Full Name */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="name"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Full Name
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>

                      <input
                        type="text"
                        className="common-input px-16"
                        id="name"
                        name="name"
                        placeholder="Full name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Email */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="email"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Email Address
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>

                      <input
                        type="email"
                        className="common-input px-16"
                        id="email"
                        name="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Mobile */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="mobile"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Phone Number
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>

                      <input
                        type="number"
                        className="common-input px-16"
                        id="mobile"
                        name="mobile"
                        placeholder="Phone Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Subject */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="subject"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Subject
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>

                      <input
                        type="text"
                        className="common-input px-16"
                        id="subject"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Message */}
                    <div className="col-sm-12">
                      <label
                        htmlFor="message"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Message
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>

                      <textarea
                        className="common-input px-16"
                        id="message"
                        name="message"
                        placeholder="Type your message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Button */}
                    <div className="col-sm-12 mt-32">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-32 rounded-8"
                      >
                        Get a Quote
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="mb-48">Get In Touch</h6>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-phone-call" />
                  </span>
                  <Link
                    to="/tel:+00123456789"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    <p>{contact.phone}</p>
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-envelope" />
                  </span>
                  <Link
                    to="/mailto:support24@marketpro.com"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    <p>{contact.gmail}</p>
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-clock" />
                  </span>
                  <Link
                    to="/mailto:support24@marketpro.com"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    <p>{contact.clock}</p>
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-globe" />
                  </span>
                  <Link
                    to="/mailto:support24@marketpro.com"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    <p>{contact.website}</p>
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-0">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-map-pin" />
                  </span>
                  <span className="text-md text-gray-900 ">
                    <p>{contact.address}</p>
                  </span>
                </div>
              </div>
              <div className="mt-24 flex-align flex-wrap gap-16">
                <Link
                  to="#"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                >
                  <span className="text-white fw-medium">
                    Get Support On Call
                  </span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                    <i className="ph ph-headset" />
                  </span>
                </Link>
                <Link
                  to="#"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                >
                  <span className="text-white fw-medium">Get Direction</span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                    <i className="ph ph-map-pin" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
     
    </>
  );
};

export default Contact;
